module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venue/venue-edit/venue-edit.component.scss
// module id = ./src/app/routes/venue/venue-edit/venue-edit.component.scss
// module chunks = 9